// extracted by mini-css-extract-plugin
export default {"loader":"ConnectionLoader_loader__1mXz7","messageContainer":"ConnectionLoader_messageContainer__1TPjO"};